import React from 'react';
import { BodyText, BoldBodyText, Button, FlexRow, SideSheet } from 'ui-toolkit';
import { IActualDepositData } from './MatchedDepositsType';
import { prettyPayerType } from 'types/order/escrow/ePayerType';
import { StyledCurrency, StyledDetail, StyledDetailsGrid } from './StyledDeposits';
import { getDateString } from 'ui-toolkit/utilities/getDateString';

export interface IMatchedDepositsSidesheetProps {
  depositData: IActualDepositData;
  onClose: () => void;
}

export const MatchedDepositsSidesheet: React.FC<IMatchedDepositsSidesheetProps> = ({ depositData, onClose }) => {
  return (
    <SideSheet
      title={'More Details'}
      onClose={onClose}
      overflow-y={'unset'}
      footer={
        <FlexRow textAlign={'center'} justifyContent={'space-between'}>
          <Button intent={'primary'} onClick={onClose} data-test-id={'close-sidesheet'}>
            Close
          </Button>
        </FlexRow>
      }
    >
      <StyledDetailsGrid columnCount={1}>
        <StyledDetail>
          <BodyText>Actual Amount</BodyText>
          <StyledCurrency value={depositData.amountCents} valueIsCents />
        </StyledDetail>
      </StyledDetailsGrid>
      <StyledDetailsGrid columnCount={3}>
        {depositData.matchedAt && (
          <StyledDetail>
            <BoldBodyText>Matched Date</BoldBodyText>
            <BodyText>{getDateString(`LLLL d, yyyy`, depositData.matchedAt)}</BodyText>
          </StyledDetail>
        )}
        {depositData.disbursedAt && (
          <StyledDetail>
            <BoldBodyText>Disbursed At</BoldBodyText>
            <BodyText>{getDateString(`LLLL d, yyyy`, depositData.disbursedAt)}</BodyText>
          </StyledDetail>
        )}
        {depositData.completedAt && (
          <StyledDetail>
            <BoldBodyText>Completed At</BoldBodyText>
            <BodyText>{getDateString(`LLLL d, yyyy`, depositData.completedAt)}</BodyText>
          </StyledDetail>
        )}
      </StyledDetailsGrid>
      <StyledDetailsGrid columnCount={2}>
        {depositData.receivingPartyName && (
          <StyledDetail>
            <BoldBodyText>Receiving Party Name</BoldBodyText>
            <BodyText>{depositData.receivingPartyName}</BodyText>
          </StyledDetail>
        )}
        {depositData.receivingPartyAccountType && (
          <StyledDetail>
            <BoldBodyText>Receiving Party Account Type</BoldBodyText>
            <BodyText>{depositData.receivingPartyAccountType}</BodyText>
          </StyledDetail>
        )}
        {depositData.receivingPartyAccountNumber && (
          <StyledDetail>
            <BoldBodyText>Receiving Party Account Number</BoldBodyText>
            <BodyText>{depositData.receivingPartyAccountNumber}</BodyText>
          </StyledDetail>
        )}
        {depositData.receivingPartyRoutingNumber && (
          <StyledDetail>
            <BoldBodyText>Receiving Party Routing Number</BoldBodyText>
            <BodyText>{depositData.receivingPartyRoutingNumber}</BodyText>
          </StyledDetail>
        )}
        {depositData.identifier && (
          <StyledDetail>
            <BoldBodyText>Identifier</BoldBodyText>
            <BodyText>{depositData.identifier}</BodyText>
          </StyledDetail>
        )}
        {depositData.bankReference && (
          <StyledDetail>
            <BoldBodyText>Bank Reference</BoldBodyText>
            <BodyText>{depositData.bankReference}</BodyText>
          </StyledDetail>
        )}
        {depositData.mismatched && (
          <StyledDetail>
            <BoldBodyText>Mismatched</BoldBodyText>
            <BodyText>{depositData.mismatched}</BodyText>
          </StyledDetail>
        )}
      </StyledDetailsGrid>
      <StyledDetailsGrid columnCount={2}>
        {depositData.spruceAccount && (
          <StyledDetail>
            <BoldBodyText>Spruce Account</BoldBodyText>
            <BodyText>{depositData.spruceAccount}</BodyText>
          </StyledDetail>
        )}
        {depositData.spruceAccountLabel && (
          <StyledDetail>
            <BoldBodyText>Spruce Account Label</BoldBodyText>
            <BodyText>{depositData.spruceAccountLabel}</BodyText>
          </StyledDetail>
        )}
        {depositData.spruceRoutingNumber && (
          <StyledDetail>
            <BoldBodyText>Spruce Routing Number</BoldBodyText>
            <BodyText>{depositData.spruceRoutingNumber}</BodyText>
          </StyledDetail>
        )}
        {depositData.payerType && (
          <StyledDetail>
            <BoldBodyText>Payer Type</BoldBodyText>
            <BodyText>{prettyPayerType[depositData.payerType]}</BodyText>
          </StyledDetail>
        )}
        {depositData.wellsFargoTransactionNumber && (
          <StyledDetail>
            <BoldBodyText>Wells Fargo Transaction Number</BoldBodyText>
            <BodyText>{depositData.wellsFargoTransactionNumber}</BodyText>
          </StyledDetail>
        )}
      </StyledDetailsGrid>
      <StyledDetailsGrid>
        {depositData.memo && (
          <StyledDetail>
            <BoldBodyText>Memo</BoldBodyText>
            <BodyText>{depositData.memo}</BodyText>
          </StyledDetail>
        )}
        {depositData.wireDetails && (
          <StyledDetail>
            <BoldBodyText>Wire Details</BoldBodyText>
            <BodyText>{depositData.wireDetails}</BodyText>
          </StyledDetail>
        )}
        {depositData.checkDetails && (
          <StyledDetail>
            <BoldBodyText>Check Details</BoldBodyText>
            <BodyText>{depositData.checkDetails}</BodyText>
          </StyledDetail>
        )}
      </StyledDetailsGrid>
    </SideSheet>
  );
};
